module.exports = __webpack_public_path__ + "img/actblue.a2fe2fb2.png";